import { AButton, AModal, ATitle, StatusFinancial } from '../../../components';
import {
  ContainerDescriptionList,
  ContainerRowModalTitle,
  DescriptionText,
  RowDescription,
} from '../styles';
import { ContainerFinancialToReceiveList } from './styles';
import { IFinancial } from '../../../shared/interfaces';
import { List } from 'antd';
import { formatDate } from '../../../shared/utils/format-date';
import { currency } from '../../../shared/utils/functions';
import { DollarCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface IFinancialToReceiveProps {
  open: boolean;
  close: () => void;
  financials: IFinancial[];
  toReceive: number;
}

const FinancialToReceive: React.FC<IFinancialToReceiveProps> = ({
  open,
  close,
  financials,
  toReceive,
}) => {
  const navigate = useNavigate();

  return (
    <AModal
      open={open}
      close={close}
      width={800}
      title={
        <ContainerRowModalTitle>
          <ATitle>Contas à receber que venceram até o momento!</ATitle>
          <ATitle color="#70c525">{currency(toReceive)}</ATitle>
        </ContainerRowModalTitle>
      }
      footer={
        <>
          <AButton onClick={close}>Fechar</AButton>
        </>
      }
    >
      <ContainerFinancialToReceiveList>
        <List
          itemLayout="horizontal"
          dataSource={financials}
          renderItem={(item) => (
            <List.Item
              actions={[
                <a
                  key="list-loadmore-edit"
                  onClick={() => navigate(`/financial/${item.id}`)}
                >
                  Editar
                </a>,
              ]}
            >
              <List.Item.Meta
                avatar={
                  <DollarCircleFilled
                    style={{ fontSize: 40, color: '#3f8600' }}
                  />
                }
                title={
                  <DescriptionText bold style={{ color: '#70c525' }}>
                    {item.client_name}
                  </DescriptionText>
                }
                description={
                  <ContainerDescriptionList>
                    <RowDescription>
                      <DescriptionText bold>Código:</DescriptionText>
                      <DescriptionText>{item.code}</DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold>Valor:</DescriptionText>
                      <DescriptionText>{currency(item.value)}</DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold>Data Vencimento:</DescriptionText>
                      <DescriptionText>
                        {formatDate(item.due_date)}
                      </DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold> Situação:</DescriptionText>
                      <DescriptionText>
                        <StatusFinancial status={item.status} />
                      </DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold> Nº Doc:</DescriptionText>
                      <DescriptionText>{item.number_doc}</DescriptionText>
                    </RowDescription>
                    <RowDescription>
                      <DescriptionText bold>Observação:</DescriptionText>
                      <DescriptionText>
                        {item.observation ?? 'Sem informação'}
                      </DescriptionText>
                    </RowDescription>
                  </ContainerDescriptionList>
                }
              />
            </List.Item>
          )}
        />
      </ContainerFinancialToReceiveList>
    </AModal>
  );
};

export default FinancialToReceive;
